import React from "react";

const WorkoutTimer = ({
  countdown,
  themeColor,
  fontFamily = "'Horizon', sans-serif",
  getAdjustedFontSize,
  getAdjustedRotation,
  workoutTransitionMessage,
}) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  function breakWordsWithLineBreaks(str) {
    if (!str) return null;
    return str.split(" ").map((word, idx) => (
      <React.Fragment key={idx}>
        {word}
        <br />
      </React.Fragment>
    ));
  }

  return (
    <>
      {/* Repetition Countdown Overlay: visually shown when >30s but kept in DOM to allow fade animation */}
      <div
        aria-hidden={!(countdown > 30)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: `linear-gradient(90deg, rgb(52 179 179 / 0%) 40%, ${themeColor} 55%)`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontFamily: fontFamily,
          zIndex: 9999,
          opacity: countdown > 30 ? 0.92 : 0,
          transform:
            countdown > 30
              ? "scale(1) translateY(0)"
              : "scale(0.95) translateY(-20px)",
          transition: "opacity 800ms ease-in-out, transform 800ms ease-in-out",
          transitionDelay: countdown > 30 ? "0ms" : "0ms",
          willChange: "opacity, transform",
          pointerEvents: "none",
        }}
      >
        {/* Countdown Timer */}
        <div
          style={{
            transform: "translateX(60%)",
            background: `linear-gradient(90deg, rgb(52 179 179 / 0%) 40%, ${themeColor} 55%)`,
            padding: "20px 40px",
            borderRadius: "15px",
            transition: "transform 400ms ease, opacity 400ms ease",
            opacity: countdown > 30 ? 1 : 0,
          }}
          className="for_transform_main"
        >
          {workoutTransitionMessage && (
            <span
              style={{
                display: "block",
                whiteSpace: "pre-line",
                wordBreak: "break-word",
                textAlign: "center",
                width: "100%",
                fontSize: getAdjustedFontSize("5rem", fontFamily, 1.2),
                lineHeight: 1.2,
                marginBottom: "0.5em",
              }}
            >
              {breakWordsWithLineBreaks(workoutTransitionMessage)}
            </span>
          )}
          <div
            style={{
              fontSize: getAdjustedFontSize("5rem", fontFamily, 2),
              fontWeight: "400",
              color: "#ffffff",
              textAlign: "center",
              zIndex: 3,
              animation: "pulse 1s ease-in-out infinite",
              WebkitTextStroke: "2px #3b3b3bff",
              transform: getAdjustedRotation(0, fontFamily),
            }}
            className="for_transform_main_text"
          >
            {formatTime(countdown)} SECS
          </div>
        </div>
      </div>

      {/* when 30 seconds or less remain show the same countdown overlay (kept in DOM to animate pop-in) */}
      <div
        className="for-res-compleatedd for-res-compleatedd1021021202"
        role="status"
        aria-hidden={!(countdown <= 30)}
        style={{
          // position: "absolute",
          // top: 70,
          // right: 0,
          color: "white",
          fontSize: getAdjustedFontSize("4rem", fontFamily, 1.2),
          fontWeight: "bold",
          textTransform: "uppercase",
          zIndex: 9999,
          pointerEvents: "none",
          fontFamily: fontFamily,
          WebkitTextStroke: "2px #000",
          opacity: countdown <= 30 ? 1 : 0,
          transition:
            "transform 800ms ease-in-out 300ms, opacity 800ms ease-in-out 300ms",
          willChange: "opacity, transform",
        }}
      >
        <p
          style={{
            fontSize: getAdjustedFontSize("2.8rem", fontFamily),
            margin: 0,
          }}
        >{`STARTS IN ${countdown} SECS`}</p>
      </div>
    </>
  );
};

export default WorkoutTimer;
